import {
  AppAction,
  ResponseMessage,
  ErrorMessage,
  ErrorMessageValue,
  RequestMessage,
} from '../types/actions';
import { Customer, Discount, Order } from './types';

class AddCustomerRequest extends RequestMessage {
  value: { customer: Customer };

  constructor(customer: Customer) {
    super(AppAction.ORDER_ADD_CUSTOMER, { customer });
  }
}

class AddCustomerResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(AppAction.ORDER_ADD_CUSTOMER, uuid);
  }
}

class AddCustomerError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.ORDER_ADD_CUSTOMER, uuid, value);
  }
}

class GetCustomerRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(AppAction.ORDER_GET_CUSTOMER);
  }
}

class GetCustomerResponse extends ResponseMessage {
  value: { customer: Customer };

  constructor(uuid: string, customer: Customer) {
    super(AppAction.ORDER_GET_CUSTOMER, uuid, { customer });
  }
}

class GetCustomerError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.ORDER_GET_CUSTOMER, uuid, value);
  }
}

class RemoveCustomerRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(AppAction.ORDER_REMOVE_CUSTOMER);
  }
}

class RemoveCustomerResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(AppAction.ORDER_REMOVE_CUSTOMER, uuid);
  }
}

class RemoveCustomerError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.ORDER_REMOVE_CUSTOMER, uuid, value);
  }
}

class AddDiscountRequest extends RequestMessage {
  value: { orderLineItemDiscount: Discount };

  constructor(orderLineItemDiscount: Discount) {
    super(AppAction.ORDER_ADD_DISCOUNT, { orderLineItemDiscount });
  }
}

class AddDiscountResponse extends ResponseMessage {
  value: { uid: string };

  constructor(uuid: string, discountUid: string) {
    super(AppAction.ORDER_ADD_DISCOUNT, uuid, { uid: discountUid });
  }
}

class AddDiscountError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.ORDER_ADD_DISCOUNT, uuid, value);
  }
}

class RemoveDiscountRequest extends RequestMessage {
  value: { uid: string };

  constructor(uid: string) {
    super(AppAction.ORDER_REMOVE_DISCOUNT, { uid });
  }
}

class RemoveDiscountResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(AppAction.ORDER_REMOVE_DISCOUNT, uuid);
  }
}

class RemoveDiscountError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.ORDER_REMOVE_DISCOUNT, uuid, value);
  }
}

class RetrieveOrderRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(AppAction.ORDER_RETRIEVE);
  }
}

class RetrieveOrderResponse extends ResponseMessage {
  value: { order: Order };

  constructor(uuid: string, order: Order) {
    super(AppAction.ORDER_RETRIEVE, uuid, { order });
  }
}

class RetrieveOrderError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.ORDER_RETRIEVE, uuid, value);
  }
}

export {
  AddCustomerRequest,
  AddCustomerResponse,
  AddCustomerError,
  GetCustomerRequest,
  GetCustomerResponse,
  GetCustomerError,
  RemoveCustomerRequest,
  RemoveCustomerResponse,
  RemoveCustomerError,
  AddDiscountRequest,
  AddDiscountResponse,
  AddDiscountError,
  RemoveDiscountRequest,
  RemoveDiscountResponse,
  RemoveDiscountError,
  RetrieveOrderRequest,
  RetrieveOrderResponse,
  RetrieveOrderError,
};
